<template>
    <div class="wrap">
        <Header />
        <div class="main">
            <div class="content">
                <div class="imgbox">
                    <img src="../../../assets/aotuo/xq1.jpg" alt="">
                </div>
                <div class="cont">
                    <h3>轮式AI巡检机器人</h3>
                    <p>产品可应用于：电力、油田、铁路变电站，天然气站、石化工厂、机场、智慧园区等多种户外场景</p>
                    <ul>
                        <li>支持：</li>
                        <li>机器人租赁</li>
                        <li>轻定制1台起定|配送服务</li>
                        <li>重定制1台起定|其他加工</li>
                    </ul>
                    <button @click="dialogFormVisible = true">立即定制</button>
                </div>
            </div>
            <div class="introduce">
                <h4>产品介绍</h4>
                <p>轮式巡检机器人基于“四轮八驱”驱动平台，可实现全向运动，适应多种复杂路况，采用车体轻量
                    化设计，功能模块化组合。支持自主、手动、联动等多种巡检模式。工作人员只需根据实际需求，提前
                    选择巡检模式、设定巡检时间、线路、内容，巡检机器人便可按照设定指令完成巡检任务，及时发现和
                    预警存在的安全隐患。同时，工作人员还可远程监控，实时掌握环境信息。
                </p>
                <h4>产品功能</h4>
                <ul>
                    <li>
                        1. 路径规划
                        <p>自主定位，智能避障，路径规划，预防错检、漏检等现象；</p>
                    </li>
                    <li>
                        2.图像识别
                        <p>识别设备状态信息、识别分析动物和人员等异常行为，抓取特征图像；</p>
                    </li>
                    <li>
                        3. 环境感知
                        <p>对环境信息监测，遇局部高温、有毒气体、火灾等及时报警，安全可防可控；</p>
                    </li>
                    <li>
                        4. 自主巡检
                        <p>自主充电，全天候在线，解决人员紧缺难题，实现无人化值守；</p>
                    </li>
                    <li>
                        5. 终端协同
                        <p>监控视频回传终端，实现决策与执行同步，并支持实时录制和回放等功能；</p>
                    </li>
                    <li>
                        6. 故障预警
                        <p>对危险、可疑信息进行分析警示，实时传达至后台。</p>
                    </li>
                </ul>
                <h4>产品展示</h4>
                <div class="boxshow">
                    <img src="../../../assets/aotuo/xq2.png" alt="">
                    <img src="../../../assets/aotuo/xq3.png" alt="">
                    <img src="../../../assets/aotuo/xq4.png" alt="">
                    <img src="../../../assets/aotuo/xq5.png" alt="">
                    <img src="../../../assets/aotuo/xq6.png" alt="">
                    <img src="../../../assets/aotuo/xq7.png" alt="">
                </div>
            </div>
            <el-dialog title="立即定制" :visible.sync="dialogFormVisible" center>
                <el-form :model="form">
                    <p>联系信息</p>
                    <el-form-item label="姓名:" :label-width="formLabelWidth">
                        <el-input v-model="form.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="电话:" :label-width="formLabelWidth">
                        <el-input v-model="form.number" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="备注:" :label-width="formLabelWidth">
                        <el-input type="textarea" v-model="form.desc" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitForm('form')">立即定制</el-button>
                </div>
            </el-dialog>
        </div>
        <Sidebar />
        <Footer />
    </div>
</template>
<script>
import Header from '../../../components/Head'
import Sidebar from '../../../components/Sidebar.vue'
import Footer from '../../../components/Footer'

export default {
    name: "ProductDetail",
    components: {
        Header,
        Sidebar,
        Footer,
    },
    data() {
        return {
            isActive: 1,
            form: {
                name: '',
                number: '',
                desc: '',
            },
            dialogFormVisible:false,
            formLabelWidth: '50px',
        };
    },
    computed: {

    },
    created() {

    },
    mounted() {
    },
    methods: {
        // 立即定制弹窗提交
        submitForm() {
            this.dialogFormVisible = false;
            console.log('submit!2', this.form);
        },
    },
}
</script>
<style lang="less" scoped>
.main {
    width: 100%;
    margin: auto;
}

.content {
    width: 1200px;
    margin: auto;
    margin-top: 116px;
    display: flex;

    .imgbox {
        margin-right: 38px;

        img {
            width: 588px;
        }
    }

    .cont {
        h3 {
            font-weight: 600;
            color: #333333;
            font-size: 30px;
            line-height: 45px;
            margin-top: 8px;
        }

        p {
            font-weight: 600;
            color: #0039c6;
            font-size: 18px;
            margin: 20px 0px;
        }

        ul {
            color: #888888;
            font-size: 14px;

            li {
                font-size: 14px;
                margin: 20px 0;
            }
        }

        button {
            width: 136px;
            height: 48px;
            color: #ffffff;
            background: #0039c6;
            border-radius: 6px;
            border: 0;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            margin-top: 30px;
        }
    }
}

.introduce {
    width: 1200px;
    margin: 86px auto;

    h4 {
        font-size: 28px;
        color: #0039c6;
        margin: 20px 0;
    }

    p {
        font-size: 22px;
        line-height: 2;
    }

    ul {
        li {
            font-size: 22px;

            p {
                font-size: 20px;
                margin: 10px 0;
                text-indent: 2em;
            }
        }
    }

    .boxshow {
        img {
            width: 600px;
        }
    }
}
/deep/.el-dialog{
    width: 38%;
}
/deep/ .el-dialog__header{
    background:#f6f8fb;
    padding: 20px 20px 20px;
    span{
        color:#333333;
        font-size:22px;
    }
    
}
.el-form{
    p{
        font-weight:600;
        color:#333333;
        font-size:18px;
        margin-bottom: 18px;
    }
}
/deep/.el-input input{
    background:#f5f6fa;
    border-radius:4px;
    border: 0;
}
/deep/.el-button{
    width:182px;
}
/deep/.el-dialog__body{
    padding-bottom: 10px;
}
.el-button--primary {
    color: #FFF;
    background-color: #0039c6;
    border-color: #0039c6;
}
/deep/.el-textarea__inner{
    background:#f5f6fa;
    border: 0;
}
</style>